export interface FieldNameSegment {
    name: string;
    separator: string;
}

export function formatFieldNameSegments(fieldNames: string[]): FieldNameSegment[] {
    return fieldNames.map((name, index) => {
        const isLast: boolean = index === fieldNames.length - 1;
        if (isLast) {
            return { name, separator: '' };
        }

        if (fieldNames.length === 2) {
            return { name, separator: ' and ' };
        }

        const isSecondToLast: boolean = index === fieldNames.length - 2;
        return { name, separator: isSecondToLast ? ', and ' : ', ' };
    });
}
